var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          ref: "menu",
          staticClass: "context-menu",
          style: _vm.style,
          on: {
            mouseover: _vm.mouseOverMenu,
            mouseleave: _vm.mouseLeaveMenu,
            contextmenu: function ($event) {
              $event.preventDefault()
            },
            wheel: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _vm.searchBar
            ? _c("Search", {
                on: { search: _vm.onSearch },
                model: {
                  value: _vm.filter,
                  callback: function ($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter",
                },
              })
            : _vm._e(),
          _vm._l(_vm.filtered, function (item) {
            return _c("Item", {
              key: item.title,
              attrs: {
                item: item,
                args: _vm.args,
                delay: _vm.delay / 2,
                menuHovered: _vm.hovered,
              },
            })
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }